// extracted by mini-css-extract-plugin
module.exports = {"character-style-1":"FormText_character-style-1__1gi9K","FormText":"FormText_FormText__27VUv","FormText__link":"FormText_FormText__link__19WWM"};